var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { forwardRef, useEffect, useMemo, } from 'react';
import { get, Label, muiBankTheme, ErrorNotification, ScreenReaderOnly, } from '@ally/metronome-ui';
import styled, { css, ThemeProvider, } from 'styled-components';
import { getNormalizedAccountType, getAccountTypeColor, getAccountLabel, } from '../utils';
import AccountSelector from './AccountSelector';
import SelectedAccount from './SelectedAccount';
var StyledAccountSelect = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 100%;\n  position: relative;\n\n  ::before {\n    content: '';\n    display: block;\n    height: calc(100% - ", ");\n    left: ", ";\n    position: absolute;\n    top: ", ";\n    width: 6px;\n    z-index: 1;\n\n    ", "\n  }\n"], ["\n  max-width: 100%;\n  position: relative;\n\n  ::before {\n    content: '';\n    display: block;\n    height: calc(100% - ", ");\n    left: ", ";\n    position: absolute;\n    top: ", ";\n    width: 6px;\n    z-index: 1;\n\n    ",
    "\n  }\n"])), get.space('xs'), get.space('xxs'), get.space('xxs'), function (_a) {
    var accountType = _a.accountType;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), getAccountTypeColor(accountType));
});
var AccountTile = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 52px;\n  min-height: 52px;\n  width: 100%;\n  max-width: 100%;\n  border: 1px solid ", ";\n  background: ", ";\n"], ["\n  height: 52px;\n  min-height: 52px;\n  width: 100%;\n  max-width: 100%;\n  border: 1px solid ", ";\n  background: ", ";\n"])), get.colors('slate-3'), get.colors('white'));
var AccountSelect = forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, accounts = _a.accounts, label = _a.label, _b = _a.value, value = _b === void 0 ? '' : _b, prompt = _a.prompt, terminal = _a.terminal, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.disableAutofill, disableAutofill = _d === void 0 ? false : _d, error = _a.error, _e = _a.required, required = _e === void 0 ? false : _e, _f = _a.ariaRequired, ariaRequired = _f === void 0 ? false : _f, _g = _a.ariaDescribedby, ariaDescribedby = _g === void 0 ? '' : _g, dataTestId = _a.dataTestId, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var displayOnly = useMemo(function () { return !terminal && accounts.length === 1; }, [
        terminal,
        accounts,
    ]);
    var account = useMemo(function () { return accounts.find(function (_a) {
        var accountId = _a.accountId;
        return accountId === value;
    }); }, [accounts, value]);
    var accountType = useMemo(function () {
        var _a = account || {}, group = _a.group, type = _a.type;
        return getNormalizedAccountType(group, type);
    }, [account]);
    var onAccountSelect = function (e) {
        var newValue = e.target.value;
        if (onChange)
            onChange(newValue, e);
    };
    /**
     * There are two circumstances where the value of the select needs to be set
     * to the first account programmatically:
     *
     * 1) there is no prompt and the value is undefined
     * 2) there is a prompt, but there only one account and no terminal (i.e. "Other")
     */
    useEffect(function () {
        var _a;
        if (!onChange)
            return;
        if (disableAutofill)
            return;
        if ((!prompt && !value) || displayOnly) {
            onChange((_a = accounts[0]) === null || _a === void 0 ? void 0 : _a.accountId);
        }
    }, [accounts, displayOnly, prompt, value]);
    return (React.createElement(ThemeProvider, { theme: muiBankTheme },
        React.createElement(React.Fragment, null,
            label && (React.createElement(Label, { htmlFor: id, id: id + "-lbl", textTransform: "uppercase", display: "inline-block", mb: "xxs" }, label)),
            React.createElement(StyledAccountSelect, { accountType: accountType },
                !!account && (React.createElement(SelectedAccount, { account: account, disabled: disabled })),
                displayOnly && !disableAutofill ? (React.createElement(AccountTile, { id: id },
                    React.createElement(ScreenReaderOnly, null, getAccountLabel(accounts[0])))) : (React.createElement(AccountSelector, { ref: ref, id: id, className: className, accounts: accounts, prompt: prompt, terminal: terminal, value: value, disabled: disabled, required: required, error: error, ariaDescribedby: ariaDescribedby, ariaRequired: ariaRequired, ariaLabelledby: label ? id + "-lbl" : '', "data-testid": dataTestId, onAccountSelect: onAccountSelect, onFocus: onFocus, onBlur: onBlur }))),
            error && React.createElement(ErrorNotification, { errorMessage: error }))));
});
export default AccountSelect;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map